document.addEventListener("DOMContentLoaded", async () => {
    let vehicle_ul_loader_parent = document.querySelector(".vehicle_ul_loader_parent");
    let card_ul_wrapper_starter = document.querySelector(".card_ul_wrapper_starter");
    // init start
    if (vehicle_ul_loader_parent) {
        async function fetchAllProducts() {
            let hasNextPage = true;
            let endCursor = null;
            let allVariants = [];

            const endpoint = `/api/2025-07/graphql`;

            const headers = {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": "4641a88956433b2e9a808352a05d39b9",
            };

            const fetchProducts = async (cursor = null) => {
                const query = `
      {
        products(
          first: 250${cursor ? `, after: "${cursor}"` : ""},
          query: "metafield:prd.all_details*"
        ) {
          pageInfo {
            hasNextPage
            endCursor
          }
          nodes {
            id
            title
            handle

            detailsMeta: metafields(
              identifiers: [{ namespace: "prd", key: "all_details" }]
            ) {
              value
              type
            }

            imageMeta: metafields(
              identifiers: [{ namespace: "custom", key: "body_and_year_image" }]
            ) {
              key
              namespace
              reference {
                ... on MediaImage {
                  image {
                    originalSrc
                  }
                }
              }
            }

            selectedOrFirstAvailableVariant {
              id
              sku
            }

            variants(first: 100) {
              nodes {
                title
                id
                sku
                availableForSale
              }
            }
          }
        }
      }
    `;

                try {
                    const response = await fetch(endpoint, {
                        method: "POST",
                        headers,
                        body: JSON.stringify({ query }),
                    });

                    const data = await response.json();

                    if (data.errors) {
                        console.error("GraphQL errors:", data.errors);
                        return null;
                    }

                    return data.data.products;
                } catch (error) {
                    console.error("Error fetching GraphQL data:", error);
                    return null;
                }
            };

            while (hasNextPage) {
                const productsData = await fetchProducts(endCursor);

                if (!productsData) break;

                productsData.nodes.forEach((product) => {
                    product.variants.nodes.forEach((variant) => {
                        if (product.detailsMeta[0] != null) {
                            const metaValue = JSON.parse(product.detailsMeta[0].value);

                            const { make, model, body, engineYear, engineType, motorCode, hp } =
                                metaValue;

                            allVariants.push({
                                make,
                                model,
                                body,
                                engineYear,
                                engineType,
                                motorCode,
                                hp,

                                handle: product.handle,

                                productId: product.id.split("/").pop(),
                                variantId: variant.id.split("/").pop(),
                                selectedVariantId: product.selectedOrFirstAvailableVariant.id
                                    .split("/")
                                    .pop(),

                                sku: variant.sku,
                                variantTitle: variant.title,
                                availableForSale: variant.availableForSale,

                                image: product.imageMeta[0]
                                    ? product.imageMeta[0].reference.image.originalSrc
                                    : "",
                            });
                        }
                    });
                });

                hasNextPage = productsData.pageInfo.hasNextPage;
                endCursor = productsData.pageInfo.endCursor;
            }

            console.log("allVariants--->", allVariants);
            return allVariants;
        }

        const allVariants = await fetchAllProducts();
        window.allProductDetails = allVariants;

        const allProductDetails = window.allProductDetails;
        var data = [];

        allProductDetails.forEach((each) => {
            const { make, model, body, engineYear } = each;

            let makeEntry = data.find((entry) => entry[make]);

            if (!makeEntry) {
                makeEntry = { [make]: {} };
                data.push(makeEntry);
            }

            const modelMap = makeEntry[make];

            if (!modelMap[model]) {
                modelMap[model] = {};
            }

            if (!modelMap[model][body]) {
                modelMap[model][body] = {};
            }

            if (!modelMap[model][body][engineYear]) {
                modelMap[model][body][engineYear] = [];
            }

            modelMap[model][body][engineYear].push(each);
        });

        // ----------------- stepbuttons parts -----------------

        setupButton("advntgBtn", ".advantage-section");
        setupButton("nextbtn", ".growth-section");
        setupButton("showInstallBtn", ".install-section");
        setupButton("showMobileBtn", ".mobile-app-section");
        setupButton("showReviewBtn", ".review-section", "looxReviewsFrame");

        function setupButton(buttonId, sectionClass, frameId = null) {
            const button = document.getElementById(buttonId);
            const section = document.querySelector(sectionClass);
            const frame = frameId ? document.getElementById(frameId) : null;

            if (!button || !section) {
                console.error(`Button or section not found: ${buttonId}, ${sectionClass}`);
                return;
            }

            button.addEventListener("click", function () {
                section.style.display = "block";
                button.style.background = "#fecb04";
                section.scrollIntoView({ behavior: "smooth" });

                // Frame processing
                if (frame) {
                    frame.style.display = "block";
                }
            });
        }

        // ----------------- vehicles part -----------------

        const selector = document.querySelector(".card__selector");
        const vehicles = document.querySelector(".card__vehicles");
        const icon = selector.querySelector("svg");
        const expandedHeight = "220px";

        vehicles.style.maxHeight = expandedHeight;
        icon.classList.add("rotated");

        selector.addEventListener("click", function () {
            const isOpen = vehicles.style.maxHeight !== "0px";

            vehicles.style.maxHeight = isOpen ? "0px" : expandedHeight;
            icon.classList.toggle("rotated", !isOpen);
        });

        // ------------- other-makes.js -------------

        const ulElement = document.querySelector(".card__ul");
        const selectorText = document.querySelector(".card__selector-text");
        const outputNav = document.querySelector(".card__selector-output");
        const cardContent = document.querySelector(".card__content");
        const cardProduct = document.querySelector(".card__product");
        const unique_atc = document.querySelector(".card__product .atcBtnDrawer");
        const cardReset = document.querySelector(".card__reset");
        const cardProductOos = document.querySelector(".card__product-oos");
        const searchInput = document.querySelector(".card__search input");
        const redirectBtn = document.querySelector("#card__redirectBtn");
        const showImg = document.querySelector(".card__show_img");

        let chevronRight = `<svg stroke="#1e1e1e" fill="#1e1e1e" stroke-width="0" viewBox="0 0 24 24" height="20px" width="20px" xmlns="http://www.w3.org/2000/svg"><polyline fill="none" stroke-width="2" points="7 2 17 12 7 22"></polyline></svg>`;

        const state = {
            make: null,
            model: null,
            body: null,
            minYear: null,
            maxYear: null,
            engineYear: null,
            id: null,
            engine: null,
            image: null,
            handle: null,
            availableForSale: null,
            sku: null,
        };

        const steps = ["make", "model", "body", "engine"];
        const stepLabels = {
            make: "Select Make",
            model: "Select Model",
            body: "Select Body & Year Range",
            engine: "Select Engine",
            search: "Search Results",
        };

        let results = [];
        let activeIndex = -1;

        const _UI = () => {
            cardContent.style.display = "block";
            cardProduct.style.display = "none";
            cardReset.style.display = "none";
        };

        const findBrandData = (make) => data.find((obj) => obj[make])?.[make] || null;
        const getMakes = () => data.map((each) => Object.keys(each)[0]);

        const getModels = (make) => Object.keys(findBrandData(make) || {});

        const getMinMaxYears = (yearsObj) => {
            const yearList = Object.keys(yearsObj).map((y) => {
                const parts = y.split("-");
                const start = parseInt(parts[0]);
                const end = parts[1] && /^\d+$/.test(parts[1]) ? parseInt(parts[1]) : null;
                return [start, end];
            });

            const starts = yearList.map((y) => y[0]).filter(Boolean);
            const ends = yearList.map((y) => y[1]).filter(Boolean);

            const min = Math.min(...starts);
            const max = ends.length ? Math.max(...ends) : "+";

            return { min, max };
        };

        const displayRange = (min, max) => {
            return max === "+" ? `${min}+` : `${min} - ${max}`;
        };

        const getBodyYearPairs = (make, model) => {
            const modelData = findBrandData(make)?.[model];
            if (!modelData) return [];

            return Object.entries(modelData).map(([body, years]) => {
                const { min, max } = getMinMaxYears(years);
                return {
                    label: `${body} (${displayRange(min, max)})`,
                    body,
                    minYear: min,
                    maxYear: max,
                };
            });
        };

        const getEngineDetails = (make, model, body) => {
            const years = findBrandData(make)?.[model]?.[body];
            if (!years) return [];

            return Object.entries(years).flatMap(([year, engines]) =>
                engines.map((item) => ({
                    label: `${item.engineType} / ${item.motorCode} / ${item.hp} HP / ${year}`,
                    engine: `${item.engineType} / ${item.motorCode} / ${item.hp} HP / ${year}`,
                    engineYear: year,
                    id: item.variantId || item.id,
                    handle: item.handle,
                    image: item.image,
                    availableForSale: item.availableForSale,
                    sku: item.sku,
                })),
            );
        };

        const updateSelectorText = (step) => {
            selectorText.textContent = stepLabels[step];
        };

        const isSkuMissingOrUnknown = (sku) => {
            if (sku === null || sku === undefined) return true;
            const trimmed = String(sku).trim();
            if (trimmed === "" || trimmed.toLowerCase() === "null") return true;
            return trimmed.toLowerCase().includes("unknow"); // unknow/unknown/UNKNOW/UNKNOWN hepsini kapsar
        };

        const hasCwCode = (sku) => {
            if (!sku) return false;
            return String(sku).toLowerCase().includes("cw");
        };

        const isOutOfStockBySku = (sku) => {
            return isSkuMissingOrUnknown(sku) && !hasCwCode(sku);
        };

        const updateProductAvailabilityUI = (availableForSale, sku) => {
            const isAvailable = availableForSale === true || availableForSale === "true";
            const forceOos = isOutOfStockBySku(sku);

            if (isAvailable && !forceOos) {
                unique_atc.style.display = "flex";

                if (cardProductOos) {
                    cardProductOos.style.display = "none";
                }
            } else {
                unique_atc.style.display = "none";

                if (cardProductOos) {
                    cardProductOos.style.display = "flex";
                }
            }
        };

        const updateOutputNav = () => {
            outputNav.innerHTML = "";
            const selections = [];
            if (state.make) selections.push({ label: state.make, step: 0 });
            if (state.model) selections.push({ label: state.model, step: 1 });
            if (state.body && state.minYear)
                selections.push({
                    label: `${state.body} (${displayRange(state.minYear, state.maxYear)})`,
                    step: 2,
                });
            if (state.engine) selections.push({ label: state.engine, step: 3 });

            selections.forEach((sel, i) => {
                const btn = document.createElement("span");
                btn.className = "card__selector-output-nav";
                btn.textContent = sel.label;
                btn.setAttribute("data-step", sel.step);
                btn.addEventListener("click", () => goToStep(sel.step));
                outputNav.appendChild(btn);
                if (i !== 3) {
                    const nextSpan = document.createElement("span");
                    nextSpan.className = "card__selector-next";
                    nextSpan.innerHTML = chevronRight;
                    outputNav.appendChild(nextSpan);
                }
            });
        };

        const goToStep = (stepIndex) => {
            for (let i = stepIndex; i < steps.length; i++) {
                const key = steps[i];
                state[key] = null;
                if (key === "body") {
                    state.minYear = null;
                    state.maxYear = null;
                }
                if (key === "engine") {
                    state.id = null;
                    state.handle = null;
                    state.image = null;
                }
            }

            showImg.style.display = "none";
            showImg.innerHTML = "";

            updateOutputNav();
            handleStep(steps[stepIndex]);
            _UI();
        };

        const highlightMatch = (text, keyword) => {
            const regex = new RegExp(`(${keyword})`, "gi");
            return text.replace(regex, "<strong>$1</strong>");
        };

        const renderLi = (items, step) => {
            ulElement.innerHTML = "";

            if (step === "search") {
                const resultInfo = document.createElement("li");
                resultInfo.className = "card__li search__info";
                resultInfo.style.fontWeight = "bold";
                resultInfo.style.borderBottom = "1px solid #ccc";
                resultInfo.style.pointerEvents = "none";
                resultInfo.textContent = `${items.length} result found!`;
                ulElement.appendChild(resultInfo);
            }

            items.sort((a, b) => {
                const labelA = typeof a === "string" ? a : a.label;
                const labelB = typeof b === "string" ? b : b.label;
                return labelA.localeCompare(labelB);
            });

            items.forEach((item) => {
                const li = document.createElement("li");
                li.className = "card__li";
                const label = typeof item === "string" ? item : item.label;
                li.innerHTML =
                    step === "search" && searchInput.value
                        ? highlightMatch(label, searchInput.value.trim())
                        : label;
                li.dataset.value = label;

                if (typeof item === "object") {
                    li.dataset.body = item.body || null;
                    li.dataset.minYear = item.minYear || null;
                    li.dataset.maxYear = item.maxYear || null;
                    li.dataset.id = item.id || null;
                    li.dataset.handle = item.handle || null;
                    li.dataset.image = item.image || null;
                    li.dataset.engine = item.engine || null;
                    li.dataset.availableForSale = item.availableForSale;
                    li.dataset.type = item.type || null;
                    li.dataset.make = item.make || null;
                    li.dataset.model = item.model || null;
                    li.dataset.sku = item.sku || "";
                }

                li.addEventListener("click", () => {
                    handleSelection(step, li);
                    searchInput.value = "";
                    activeIndex = -1;
                });

                ulElement.appendChild(li);
            });
        };

        const handleSelection = (step, li) => {
            const type = li.dataset.type;

            if (step === "search") {
                if (type === "make") {
                    state.make = li.dataset.value;
                    handleStep("model");
                } else if (type === "model") {
                    state.make = li.dataset.make;
                    state.model = li.dataset.model;
                    handleStep("body");
                } else if (type === "body") {
                    state.make = li.dataset.make;
                    state.model = li.dataset.model;
                    state.body = li.dataset.body;
                    state.minYear = li.dataset.minYear;
                    state.maxYear = li.dataset.maxYear;
                    handleStep("engine");
                } else if (type === "engine") {
                    state.make = li.dataset.make;
                    state.model = li.dataset.model;
                    state.body = li.dataset.body;
                    state.engine = li.dataset.engine;
                    state.id = li.dataset.id;
                    state.handle = li.dataset.handle;
                    state.image = li.dataset.image;
                    state.availableForSale = li.dataset.availableForSale;
                    state.sku = li.dataset.sku;
                    updateOutputNav();
                    cardContent.style.display = "none";
                    cardProduct.style.display = "flex";
                    cardReset.style.display = "flex";
                    unique_atc.dataset.atc = state.id;
                    updateProductAvailabilityUI(state.availableForSale, state.sku);
                    redirectBtn.href = `/products/${state.handle}`;

                    if (state.image != "null") {
                        showImg.style.display = "flex";
                        showImg.innerHTML = `<img src="${state.image}" alt="${state.engine}" style="width:100%;max-width:400px;">`;
                    }
                    return;
                }

                updateOutputNav();
                return;
            }

            switch (step) {
                case "make":
                    state.make = li.dataset.value;
                    state.model =
                        state.body =
                        state.minYear =
                        state.maxYear =
                        state.engine =
                        state.id =
                        state.handle =
                        state.image =
                            null;
                    handleStep("model");
                    break;
                case "model":
                    state.model = li.dataset.value;
                    state.body =
                        state.minYear =
                        state.maxYear =
                        state.engine =
                        state.id =
                        state.handle =
                        state.image =
                            null;
                    handleStep("body");
                    break;
                case "body":
                    state.body = li.dataset.body;
                    state.minYear = li.dataset.minYear;
                    state.maxYear = li.dataset.maxYear;
                    handleStep("engine");
                    break;
                case "engine":
                    state.engine = li.dataset.value;
                    state.id = li.dataset.id;
                    state.handle = li.dataset.handle;
                    state.image = li.dataset.image;
                    state.availableForSale = li.dataset.availableForSale;
                    state.sku = li.dataset.sku;
                    updateOutputNav();
                    cardContent.style.display = "none";
                    cardProduct.style.display = "flex";
                    cardReset.style.display = "flex";
                    unique_atc.dataset.atc = state.id;
                    updateProductAvailabilityUI(state.availableForSale, state.sku);
                    redirectBtn.href = `/products/${state.handle}`;

                    if (state.image != "null") {
                        showImg.style.display = "flex";
                        showImg.innerHTML = `<img src="${state.image}" alt="${state.engine}" style="width:100%;max-width:400px;">`;
                    }
                    break;
            }

            updateOutputNav();
        };

        const handleStep = (step) => {
            updateSelectorText(step);
            switch (step) {
                case "make":
                    renderLi(getMakes(), "make");
                    // init start
                    console.log("dd init ->");
                    vehicle_ul_loader_parent.style.display = "none";
                    card_ul_wrapper_starter.style.display = "flex";
                    // init end
                    break;
                case "model":
                    renderLi(getModels(state.make), "model");
                    break;
                case "body":
                    renderLi(getBodyYearPairs(state.make, state.model), "body");
                    break;
                case "engine":
                    renderLi(getEngineDetails(state.make, state.model, state.body), "engine");
                    break;
            }
        };

        const searchAndRender = (query) => {
            updateSelectorText("search");
            const lowerQuery = query.toLowerCase();
            results = [];

            data.forEach((makeObj) => {
                const make = Object.keys(makeObj)[0];
                const models = makeObj[make];

                if (make.toLowerCase().includes(lowerQuery)) {
                    results.push({ label: make, type: "make" });
                }

                Object.keys(models).forEach((model) => {
                    if (model.toLowerCase().includes(lowerQuery)) {
                        results.push({ label: `${make} > ${model}`, type: "model", make, model });
                    }

                    Object.entries(models[model]).forEach(([body, years]) => {
                        const { min, max } = getMinMaxYears(years);
                        const bodyLabel = `${make} > ${model} > ${body} (${displayRange(min, max)})`;

                        if (bodyLabel.toLowerCase().includes(lowerQuery)) {
                            results.push({
                                label: bodyLabel,
                                type: "body",
                                make,
                                model,
                                body,
                                minYear: min,
                                maxYear: max,
                            });
                        }

                        Object.entries(years).forEach(([year, engines]) => {
                            engines.forEach((engine) => {
                                const engineInfo = `${engine.engineType} / ${engine.motorCode} / ${engine.hp} HP / ${year}`;
                                if (engineInfo.toLowerCase().includes(lowerQuery)) {
                                    results.push({
                                        label: `${make} > ${model} > ${body} > ${engineInfo}`,
                                        type: "engine",
                                        make,
                                        model,
                                        body,
                                        engine: engineInfo,
                                        engineYear: year,
                                        id: engine.variantId || engine.id,
                                        handle: engine.handle,
                                        image: engine.image,
                                        availableForSale: engine.availableForSale,
                                        sku: engine.sku,
                                    });
                                }
                            });
                        });
                    });
                });
            });

            results.sort((a, b) => a.label.localeCompare(b.label));
            renderLi(results, "search");
            activeIndex = -1;
        };

        searchInput.addEventListener("input", () => {
            const val = searchInput.value.trim().toLowerCase();
            const currentStep =
                steps.find((step) => {
                    const key = step;
                    return state[key] === null;
                }) || "engine";

            if (val.length === 0) {
                handleStep(currentStep);
                return;
            }

            if (currentStep === "make") {
                searchAndRender(val);
            } else {
                const listItems = [...ulElement.querySelectorAll(".card__li")].filter(
                    (li) => !li.classList.contains("search__info"),
                );

                listItems.forEach((li) => {
                    const text = li.dataset.value.toLowerCase();
                    const match = text.includes(val);
                    li.style.display = match ? "block" : "none";
                    li.innerHTML = match ? highlightMatch(li.dataset.value, val) : li.dataset.value;
                });
            }
        });

        searchInput.addEventListener("keydown", (e) => {
            const items = ulElement.querySelectorAll(".card__li:not(.search__info)");
            if (!items.length) return;

            if (e.key === "ArrowDown") {
                activeIndex = (activeIndex + 1) % items.length;
            } else if (e.key === "ArrowUp") {
                activeIndex = (activeIndex - 1 + items.length) % items.length;
            } else if (e.key === "Enter" && activeIndex >= 0) {
                items[activeIndex].click();
                return;
            }

            items.forEach((el, idx) => {
                el.classList.toggle("active", idx === activeIndex);
            });

            if (activeIndex >= 0) {
                items[activeIndex].scrollIntoView({ block: "nearest", behavior: "smooth" });
            }
        });

        handleStep("make");
        cardReset.addEventListener("click", () => goToStep(0));
    }
    // init end
});